import COLORS from "./constants/colors";
import Intro from "./Intro";
import WorkExperience from "./WorkExperience";



function Home() {
  return (
    <>
      <Intro bg={COLORS.bg_white}/>
      <WorkExperience bg={COLORS.bg_grey}/>
    </>
  );
}

export default Home;
